module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kj-Ld.b8aadf08.png";